import { Skeleton } from 'antd'
import { SkeletonNodeProps } from 'antd/es/skeleton/Node'

import { ReactNode } from 'react'

interface Props extends SkeletonNodeProps {
  children: ReactNode
  loading?: boolean
}

const SkeletonNode = ({ children, loading, ...props }: Props) => {
  return loading || typeof loading !== 'boolean' ? (
    <Skeleton.Node
      fullSize
      active
      {...props}
    />
  ) : (
    children
  )
}

export default SkeletonNode
